import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DialogeBox from '../components/DialogeBox/DialogeBox';

import {
    actionResetUDFs, actionResetMembershipUDFs, actionResetCustomerUdfs, actionValidateRecaptchaReset, actionResetCustomerAddresses,
    actionResetCustomer, actionResetIDMEUSERDATA, actionResetCostRate, actionResetMembershipPackage, actionResetExtraItems,
    actionResetTransactionFee, actionResetDonations, actionResetBookingTypes, actionResetFieldValuesState, actionResetMemberValidation,
    actionStartDiscardTime, actionResetDiscardTime, actionShopCartResetStateWithTourHold, actionShopCartResetStateWithUniqueCouponHold,
    actionShopCartResetDonation, actionShopCartResetMembershipPackage, actionShopCartResetGATicket,
    actionShopCartRemoveGiftcards, actionShopcartResetOrderProducts, actionResetGiftCards,
    actionShopCartResetDonationProduct
} from 'actions';

const { ApplyTransactionFee, CartDiscardTime, CartDiscardPopupTitle, CartDiscardPopupMsg, CartDiscardPopupButton1Text, CartDiscardPopupButton2Text,
    CartDiscardPopupTime, PaymentMethodType } = window['runConfig'];

const CartDiscardTimeController = props => {

    const [open, setopen] = useState(false);
    const [dialogetimer, setdialogetimer] = useState(CartDiscardPopupTime);

    const carddiscard = useSelector(state => state.reducerCardDiscardTime);
    const events = useSelector(state => state.reducerShopCart.events);
    const MembershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const GATickets = useSelector(state => state.reducerShopCart.GATickets);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const customerUdfs = useSelector(state => state.reducerCustomerUDFs);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const customerAddresses = useSelector(state => state.reducerCustomerAddresses.customerAddresses);
    const customer = useSelector(state => state.reducerCustomer);

    const dispatch = useDispatch();

    const ContinueButtonHandler = () => {
        setopen(false);
        setdialogetimer(CartDiscardPopupTime);
        SetCartTimer();
    }

    const DialogeTimeout = () => {
        setopen(false);
        setdialogetimer(CartDiscardPopupTime);
        actionShopCartResetDonation(dispatch);

        if (events && events.length > 0) {
            actionShopCartResetStateWithTourHold(dispatch, events);
        }

        if (shopcartreducer.tourCoupons.length > 0) {
            actionResetDonations(dispatch);
            actionShopCartResetStateWithUniqueCouponHold(dispatch);
        }

        if (shopcartreducer.cashless.length > 0) {
            actionShopCartRemoveGiftcards(dispatch);
        }

        actionResetDiscardTime(dispatch);
        actionResetMemberValidation(dispatch);
        actionResetBookingTypes(dispatch);
        actionResetExtraItems(dispatch);
        actionShopCartResetMembershipPackage(dispatch);
        actionResetMembershipPackage(dispatch);
        actionResetCostRate(dispatch);
        actionResetIDMEUSERDATA(dispatch);

        if (ApplyTransactionFee) {
            actionResetTransactionFee(dispatch);
        }

        if (bookingUDFS.bookingUDFs.length > 0) {
            actionResetUDFs(dispatch);
        }

        actionShopCartResetGATicket(dispatch);
        actionShopcartResetOrderProducts(dispatch);
        actionResetGiftCards(dispatch);
        actionShopCartResetDonationProduct(dispatch);
        actionResetFieldValuesState(dispatch);

        if (membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0) {
            actionResetMembershipUDFs(dispatch);
        }

        if (customerUdfs.customerUDFs && customerUdfs.customerUDFs.length > 0) {
            actionResetCustomerUdfs(dispatch);
        }

        if (customerAddresses && customerAddresses.length > 0) {
            actionResetCustomerAddresses(dispatch);
        }

        if (customer.customer && customer.customer.length > 0) {
            actionResetCustomer(dispatch);
        }

        if (PaymentMethodType === "GlobalPayments") {
            setTimeout(() => {
                window.location.reload();
            }, 1000)
        }

        setTimeout(() => {
            actionValidateRecaptchaReset(dispatch);
        }, 1000)
    }


    useEffect(() => {
        if (open) {

            if (dialogetimer == 0) {
                DialogeTimeout();
            }
            else {
                const timer = setTimeout(() => {
                    setdialogetimer(dialogetimer - 1);
                }, 1000);
                return () => {
                    clearTimeout(timer);
                };
            }

        }
    }, [dialogetimer]);

    const ShowDialoge = () => {
        setopen(true);
        actionResetDiscardTime(dispatch);
        setdialogetimer(dialogetimer - 1);
    }
    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }

        return res;
    }
    const SetCartTimer = () => {
        if (open == false && carddiscard.timerid == 0 && (events.length > 0 || GATickets.length > 0 || MembershipPackages.length > 0 || orderProducts.length > 0 || ShowGiftCards() || donationProducts.length > 0) && CartDiscardTime > 0) {
            let timeid = setInterval(() => {
                actionStartDiscardTime(dispatch, timeid)
            }, 1000);
        }
    }

    useEffect(() => {
        SetCartTimer();
    }, [carddiscard.timerid, events.length, GATickets.length, orderProducts.length, MembershipPackages.length, ShowGiftCards(), open, donationProducts.length])

    useEffect(() => {
        if (carddiscard.timerid > 0 && CartDiscardTime > 0 && carddiscard.DiscardTime == 0 && (events.length > 0 || GATickets.length > 0 || orderProducts.length > 0 || MembershipPackages.length > 0 || ShowGiftCards() || donationProducts.length)) {
            ShowDialoge();
        }
        if (carddiscard.timerid > 0 && events.length == 0 && GATickets.length == 0 && MembershipPackages.length == 0 && orderProducts.length == 0 && ShowGiftCards() == false && donationProducts.length == 0 && CartDiscardTime > 0) {
            actionResetDiscardTime(dispatch);
        }
    })

    const buttontext = () => {
        return "(" + dialogetimer + ")" + CartDiscardPopupButton1Text;
    }

    return (
        <DialogeBox open={open} title={CartDiscardPopupTitle}
            message={CartDiscardPopupMsg}
            button1text={buttontext()}
            button1clickhandler={DialogeTimeout}
            button2text={CartDiscardPopupButton2Text}
            button2clickhandler={ContinueButtonHandler}
        ></DialogeBox>
    );
};

export default CartDiscardTimeController;
